var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pago-plux-styles-container"},[_c('button',{staticClass:"pago-plux-styles",attrs:{"type":"button"},on:{"click":_vm.linkGenerator}},[_c('img',{attrs:{"src":_vm.imgLink,"alt":"imagen de pagoplux"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-321eb2d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/paymentsMethods/pago-plux-link.vue
// module id = 1250
// module chunks = 42